import React from "react";
 
const Balance = ({ color, className }) => {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`size-6 ${className || ""}`}
    >
      <path
        d="M12.8903 1.91441C12.9911 1.77913 13.1787 1.76114 13.3009 1.87505L14.3464 2.84968L11.0543 7.2H13.2348L15.6249 4.04156L17.5004 5.78987C17.6157 5.8974 17.6291 6.08248 17.5305 6.20724L16.7459 7.2H18.9528C19.5135 6.33472 19.3856 5.14738 18.6265 4.43981L14.4271 0.524988C13.5718 -0.27234 12.2584 -0.14645 11.5528 0.800508L6.78379 7.2H8.95145L12.8903 1.91441ZM15.0405 15.6C14.5704 15.6 14.1892 16.003 14.1892 16.5C14.1892 16.997 14.5704 17.4 15.0405 17.4H17.3108C17.781 17.4 18.1622 16.997 18.1622 16.5C18.1622 16.003 17.781 15.6 17.3108 15.6H15.0405ZM1.7027 7.5C1.7027 7.00295 2.08387 6.6 2.55405 6.6H6.10526L7.45784 4.8H2.55405C1.14349 4.8 0 6.00883 0 7.5V20.1C0 22.2539 1.6517 24 3.68919 24H17.3108C19.3483 24 21 22.2539 21 20.1V12.3C21 10.1461 19.3483 8.4 17.3108 8.4H2.55405C2.08387 8.4 1.7027 7.99705 1.7027 7.5ZM1.7027 20.1V10.0464C1.96898 10.1459 2.25554 10.2 2.55405 10.2H17.3108C18.4079 10.2 19.2973 11.1402 19.2973 12.3V20.1C19.2973 21.2598 18.4079 22.2 17.3108 22.2H3.68919C2.59208 22.2 1.7027 21.2598 1.7027 20.1Z"
        fill={color}
      />
    </svg>
  );
};
 
export default Balance;